const navItems = [
  { id: 'home', label: 'Home' },
  { id: 'projects', label: 'Demo' },
  { id: 'contact', label: 'Contact' },
];

function TopBar({ activeTab, brandLogo, onOpenContact, onOpenHome, onOpenProjects }) {
  const activeIndex = Math.max(
    navItems.findIndex((item) => item.id === activeTab),
    0
  );

  const handleNavClick = (id) => {
    if (id === 'home') {
      onOpenHome();
      return;
    }

    if (id === 'projects') {
      onOpenProjects();
      return;
    }

    onOpenContact();
  };

  return (
    <header className="topbar">
      <button className="brand-lockup brand-button" onClick={onOpenHome} type="button">
        <img alt="ATA Code House logo" className="brand-logo" src={brandLogo} />
        <span>
          ATA Code House
          <small>Secure digital products, branded systems, and client-ready engineering</small>
        </span>
      </button>

      <nav className="topnav" aria-label="Primary navigation" style={{ '--active-index': activeIndex }}>
        <span className="topnav-indicator" aria-hidden="true" />
        {navItems.map((item) => (
          <button
            className={activeTab === item.id ? 'is-active' : ''}
            key={item.id}
            onClick={() => handleNavClick(item.id)}
            type="button"
          >
            <span>{item.label}</span>
          </button>
        ))}
      </nav>
    </header>
  );
}

export default TopBar;
